module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Shoes-5b4d1392d4cbc2b2d962e9257e127ea4.svg";